import { CommonHeaders } from './commonHeaders';

export class StandardHeaders extends CommonHeaders {
  public constructor(apiKey: string) {
    super(apiKey);

    this.set('X-Api-Key', apiKey);
    this.set('X-Access-Token', 'Bearer {accessToken}');
    this.set('X-Platform-Location', '{location}');
  }
}
